import { createContext, useContext, useEffect } from 'react';
import { useNavigate, useParams, useLocation } from 'react-router-dom';

import { SUPPORTED_LANGS, DEFAULT_LANG } from '@i18n/languages';

const LanguageContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const params = useParams();

  const langParam = params.lang;

  const isValidLang = SUPPORTED_LANGS.includes(langParam);
  const lang = isValidLang ? langParam : DEFAULT_LANG;

  useEffect(() => {
    if (langParam && !isValidLang) {
      navigate(location.pathname.replace(`/${langParam}`, ''), {
        replace: true,
      });
    }
  }, [langParam, isValidLang]);

  const changeLanguage = newLang => {
    if (newLang === lang) return;

    const segments = location.pathname.split('/').filter(Boolean);

    if (SUPPORTED_LANGS.includes(segments[0])) {
      segments.shift();
    }

    const pathWithoutLang = segments.join('/');

    const newPath =
      newLang === DEFAULT_LANG
        ? `/${pathWithoutLang}`
        : `/${newLang}/${pathWithoutLang}`;

    navigate(newPath || '/', { replace: true });
  };

  useEffect(() => {
    document.documentElement.lang = lang;
    document.documentElement.dir = lang === 'ar' ? 'rtl' : 'ltr';
  }, [lang]);

  return (
    <LanguageContext.Provider value={{ lang, changeLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => useContext(LanguageContext);
